import React from 'react';
import { CruiseHighlightListProps } from '../../CruiseHighlightList/CruiseHighlightList.types';
import { CruiseHighlightPillText } from '../../CruiseHighlightList/CruiseHighlightList.styles';
import { RefinedCruiseHighlightListBase, RefinedCruiseHighlightPill } from './RefinedCruiseHighlightList.styles';
import { getKey } from 'lib/utilities';

function RefinedCruiseHighlightList({ highlights }: CruiseHighlightListProps) {
  return (
    <RefinedCruiseHighlightListBase>
      {highlights.map((highlight,i) =>(
        <RefinedCruiseHighlightPill key={getKey(highlight.id,i)} highlight={highlight}>
          <CruiseHighlightPillText shape={highlight.shape}>
            {highlight.label}
          </CruiseHighlightPillText>
        </RefinedCruiseHighlightPill>
      ))}
    </RefinedCruiseHighlightListBase>
  );
}

export default RefinedCruiseHighlightList;